/* =========
 * 这里放 "前置拦截" —— 零闪屏逻辑
 * ========= */
(function redirectLegacyDocs() {
    const href = window.location.href.toLowerCase();
    const path = window.location.pathname.toLowerCase();
    const hash = window.location.hash.toLowerCase();

    // ① 原有 introduce.html
    const isLegacyIntroduce =
        /\/docs(\/[a-z\-]+)?\/swap\/introduce\.html$/.test(path);

    // ② 新增 changelog（hash 路由）
    const isLegacyChangelog =
        path.startsWith("/docs/") &&
        /#\/en-us\/(swapv2|cswap|spot)\/changelog$/.test(hash);

    if (!isLegacyIntroduce && !isLegacyChangelog) return;

    let newUrl;
    if (/\/zh-(tw|hk)\//.test(href)) {
        newUrl = "https://bingx-api.github.io/docs-v3/#/zh-tw/info";
    } else {
        newUrl = "https://bingx-api.github.io/docs-v3/#/en/info";
    }

    window.location.replace(newUrl);
})();


import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
import VueClipboard from 'vue-clipboard2'

import hljs from 'highlight.js/lib/core'
import 'highlight.js/styles/atom-one-dark.css'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import go from 'highlight.js/lib/languages/go'
import shell from 'highlight.js/lib/languages/shell'
import java from 'highlight.js/lib/languages/java'
import python from 'highlight.js/lib/languages/python'
import csharp from 'highlight.js/lib/languages/csharp'
// import no from 'highlight.js/lib/languages/javascript'
import php from 'highlight.js/lib/languages/php'
import html from 'highlight.js/lib/languages/vbscript-html'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import store from './store'
import routes from './router'
import Main from './Main.vue'
import { CODE_LANG_KEY } from './utils'

hljs.registerLanguage(CODE_LANG_KEY.js, javascript)
hljs.registerLanguage('json', json)
hljs.registerLanguage(CODE_LANG_KEY.go, go)
hljs.registerLanguage(CODE_LANG_KEY.shell, shell)
hljs.registerLanguage(CODE_LANG_KEY.java, java)
hljs.registerLanguage(CODE_LANG_KEY.python, python)
hljs.registerLanguage(CODE_LANG_KEY.csharp, csharp)
hljs.registerLanguage(CODE_LANG_KEY.php, php)
hljs.registerLanguage(CODE_LANG_KEY.html, html)
hljs.registerLanguage(CODE_LANG_KEY.nodejs, javascript)

Vue.use(VueScrollTo, {
  container: "#scroll-container",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
})
Vue.use(Element)
Vue.use(VueClipboard)
Vue.use(Router)

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.prototype.$hljs = hljs

const router = new Router({
	mode: 'hash',
  routes: routes,
})

router.beforeEach((to, from, next) => {
  if(to.meta && to.meta.title) {
    document.title = `${to.meta.title} | BingX API Docs`
  }
  next()
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(Main),
})



// WEBPACK FOOTER //
// ./src/main.js